import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailPageLayout',
  props: {
  treeTitle: { type: String, default: "" },
  bodyTitle: { type: String, default: "" },
},
  emits: ["country-change"],
  setup(__props, { emit }) {





const dataType = ref("CN");

const onRadioChange = (value: string) => {
  emit("country-change", value);
};

return { __sfc: true,emit, dataType, onRadioChange }
}

})